<template>
  <div class="app">
    <AppHeader v-if="showAppChrome"/>
    <div class="app-body" :class="{ 'app-body-public': !showAppChrome }">
      <Sidebar v-if="showAppChrome" :navItems="nav"/>
      <main class="main" :class="{ 'main-public': !showAppChrome }">
        <!-- <breadcrumb :list="list"/> -->
        <div class="container-fluid backoffice-content">
          <router-view></router-view>
        </div>
      </main>
      <!-- <AppAside/> -->
    </div>
    <!-- <AppFooter/> -->
  </div>
</template>

<script>
import nav from '../_nav'
import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb
  },
  data () {
    return {
      nav: nav.items
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    },
    showAppChrome () {
      return this.$route.matched.some(route => route.meta && route.meta.requiresAuth)
    }
  }
}
</script>
<style scoped>
.backoffice-content {
  overflow-x: auto;
  overflow-y: auto;
}
.app-body-public {
  margin-top: 0;
}
.main-public {
  margin-left: 0 !important;
}
.main-public .backoffice-content {
  padding-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/containers/Full.vue